// removed by extract-text-webpack-plugin
module.exports = {"base":"KineticScrolling_base--2Ssn4","wrapper":"KineticScrolling_wrapper--3O4RL","scrolledLeft":"KineticScrolling_scrolledLeft--u1KM0","scrolledRight":"KineticScrolling_scrolledRight--2-OA2","view":"KineticScrolling_view--3F4Oy","arrow":"KineticScrolling_arrow--3MreV"};


//////////////////
// WEBPACK FOOTER
// ./components/KineticScrolling/KineticScrolling.scss
// module id = 462
// module chunks = 11 12